import {
    Component, OnInit, ElementRef, forwardRef, Input, OnChanges, Output, EventEmitter,
    Renderer2, OnDestroy, Self, Query, QueryList, Directive, Provider, ViewEncapsulation
} from '@angular/core';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule, FormGroup, FormArray, FormBuilder, Validators, FormControl } from '@angular/forms';
import { RouterModule, Router } from '@angular/router';

import {
    NG_VALUE_ACCESSOR
    , ControlValueAccessor
    , SelectControlValueAccessor
} from '@angular/forms';


import { CustomCodeValuesController, CustomCodeTypeRequest } from '../ddlbyrequesttype/customdatabyrequesttype.interface';
import { CUstomDataByRequestTypeService } from '../ddlbyrequesttype/customdatabyrequesttype.service';





import { AppData } from '../../models/appdata';
import { ApiResponseModel } from '../../models/api_response_model';



const noop = () => {
};


export const CUSTUM_PatientAutoSearch_Value_ACCESSOR: any =
    {
        provider: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => AutoSearchComponent),
        multi: true
    };


@Component({

    selector: 'AutoSearch',

    templateUrl: './autosearch.component.html',
    host: {
        '(document:click)': 'handleClick($event)',
    },
    providers: [CUstomDataByRequestTypeService
        
        ,
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AutoSearchComponent),
            multi: true
        }

    ],

})
export class AutoSearchComponent implements OnInit
    , ControlValueAccessor
{
   
    private innerValue: any = '';
    private isRequesting: boolean = false;
    
    private onTouchedCallback: () => void = noop;
    private onChangeCallback: (_: any) => void = noop;

    //
    public key: number;

    @Input()
    get Key() {
      return this.key;
    }

    @Output() keyChange = new EventEmitter();
    set Key(value: number) {
      this.key = value;
      //  alert(this.Key);       
      this.keyChange.emit(this.key);
    }

    //get accessor
    get value(): any {
        return this.innerValue;
    };

    //set accessor including call the onchange callback
    set value(v: any) {
        if (v !== this.innerValue) {
            this.innerValue = v;
            this.onChangeCallback(v);
        }
    }

//http://almerosteyn.com/2016/04/linkup-custom-control-to-ngcontrol-ngmodel

    //From ControlValueAccessor interface
    writeValue(value: any) {
        if (value !== this.innerValue) {
            this.innerValue = value;
        }
    }

    //From ControlValueAccessor interface
    registerOnChange(fn: any) {
        this.onChangeCallback = fn;
    }

    //From ControlValueAccessor interface
    registerOnTouched(fn: any) {
        this.onTouchedCallback = fn;
    }
    onChange(Event: any) {
        //alert("hi");
        this.innerValue = Event;
        this.onTouchedCallback();
        this.onChangeCallback(this.innerValue);
        this.filter();
       // console.log(this.innerValue);
    }

    constructor(
        private _renderer: Renderer2,
        private _elementRef: ElementRef,
        public _router: Router, public CUstomDataByRequestTypeService: CUstomDataByRequestTypeService) {
    }
    

    ngOnInit() {
      this.CurrentCustomCodeTypeRequest = new CustomCodeTypeRequest();
      this.CurrentCustomCodeTypeRequest.RequestedType = this.RequestedType;
      this.CurrentCustomCodeTypeRequest.CustomType = this.CustomType;
      this.CurrentCustomCodeTypeRequest.StringContains = this.StringContains;
      this.CurrentCustomCodeTypeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms || { xUserName: 'admin', xAuthGenKEY: '' } as any;

      this.CurrentCustomCodeValuesController = new Array<CustomCodeValuesController>();
        
      this.filter();
    }

    //
    public filteredList = [];
    public AutoComplete: CustomCodeValuesController[];
    @Input() RequestedType: string;

    @Input() public FacilityCode: number = 0;
    @Input() public ActorCode: number = 0;
    @Input() public CustomCode: number = 0;
    @Input() public CustomType: string = "0";
    @Input() public StringContains: string = "0";
    public ApiResData: ApiResponseModel;

    CurrentCustomCodeTypeRequest: CustomCodeTypeRequest;
    CurrentCustomCodeValuesController: CustomCodeValuesController[];

    filter() {
        if (this.innerValue !== "") {
            var searchdata = this.innerValue;
            this.AutoFillQuery(searchdata);
            this.onTouchedCallback();
        } else {
            this.filteredList = [];
        }
    }
    AutoFillQuery(filter: string) {
      if (!this.CurrentCustomCodeTypeRequest) {
        this.CurrentCustomCodeTypeRequest = new CustomCodeTypeRequest();
      }
      this.CurrentCustomCodeTypeRequest.StringContains = filter;
      this.RequestedTypeValueByType();
    }
   
    select(item) {
      var a = (this.AutoComplete || []).filter(x => (x.SearchName || (x as any).searchName || x.DisplayName || (x as any).displayName) === item);
      if (a.length > 0) {
        this.Key = a[0].Code != null ? a[0].Code : (a[0] as any).code;
        this.innerValue = a[0].DisplayName || (a[0] as any).displayName || (a[0] as any).SearchName;
        this.onTouchedCallback();
        this.onChangeCallback(this.innerValue);
      }
      else {
        this.key = 0;
      }
      this.filteredList = [];
    }
    handleClick(event) {
        var clickedComponent = event.target;
        var inside = false;
        do {
            if (clickedComponent === this._elementRef.nativeElement) {
                inside = true;
            }
            clickedComponent = clickedComponent.parentNode;
        } while (clickedComponent);
        if (!inside) {
            this.filteredList = [];
        }
    }
    
    RequestedTypeValueByType(): void {
      this.StartRefreshing();

      this.CUstomDataByRequestTypeService.GetCustomDataByRequestedType(this.CurrentCustomCodeTypeRequest).subscribe
        (
        (result) => {
          this.ApiResData = result;
          if (!this.ApiResData.hasError) {
            const rawResult = this.ApiResData.Result || (this.ApiResData as any).result || [];
            this.CurrentCustomCodeValuesController = rawResult;
            this.AutoComplete = rawResult;
            this.filteredList = (this.CurrentCustomCodeValuesController || []).filter((el: any) => {
              const searchName = el.SearchName || el.searchName || el.DisplayName || el.displayName || '';
              return searchName.toLowerCase().indexOf((this.innerValue || '').toLowerCase()) > -1;
            });
            this.stopRefreshing();
          }
          else {
            this.stopRefreshing();
            if (this.ApiResData.ErrorData != "") {
              alert(this.ApiResData.ErrorData);
            }
            else {
              alert(' Failed Due to Internal Error.... Please Contact Admin..');
            }
          }


        },

        (error) => {
          //alert("Error in Reload");
          if (error == "401 - Unauthorized") {
            alert(error);
            this.stopRefreshing();



          }
          else {
            alert(error);


            this.stopRefreshing();
          }
        }
        );;

    }
    private stopRefreshing() {
      this.isRequesting = false;

    }
    private StartRefreshing() {
      this.isRequesting = true;

    }

}
